import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-version-dialog-v2',
  imports: [CommonModule, FormsModule],
  templateUrl: './version-dialog-v2.component.html',
  styleUrl: './version-dialog-v2.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VersionDialogV2Component {
  @Input() mode: 'create' | 'restore' = 'create';
  @Input() targetVersion = 1;
  @Input() resultVersion = 1;
  @Input() languageLabel = 'EN';
  @Input() showUnsavedNote = false;
  @Input() busy = false;

  @Output() confirm = new EventEmitter<string | null>();
  @Output() closeDialog = new EventEmitter<void>();

  protected comment = '';

  @HostListener('document:keydown.escape')
  protected onEscapeKey(): void {
    this.closeDialog.emit();
  }

  protected onConfirm(): void {
    this.confirm.emit(this.comment.trim() || null);
  }

  protected onCancel(): void {
    this.closeDialog.emit();
  }
}
